// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { getNestedByString, setNestedValueInObject } from 'helpers/reduxFormFunctions'
import { fetchAntennaSpecByAntennaCode } from 'helpers/api'
import { UNCAUGHT_ERROR } from 'errors'

// to make sure the antenna code is unique, we hit the /antenna-specs API and if it returns
// a 404 we're good, the code doesn't exist. but if it returns an entity, then it's not unique.
// so in this scenarion we actually want to catch the 404 for success.
// any thing other than a 404 error will be thrown and displayed to the user.
const antennaCodeIsUnique = async (formValues, f, props, pathString) => {
  const {
    asyncErrors = {},
  } = props

  // no need to run this validation on submit.
  if (!pathString) {
    return
  }

  const hasAsyncErrors = Object.keys(asyncErrors).length
  const v = getNestedByString(formValues, pathString)

  // don't hit the api if there's no value to check against.
  if (!hasAsyncErrors && !v.length) {
    return
  } else if (!v.length) {
    // even if there's no value, throw the asyncErrors object since
    // there may already be other async errors that we want to keep
    throw asyncErrors
  }

  try {
    const { entity } = await fetchAntennaSpecByAntennaCode(v)

    // if we found a match, throw an error that the code is not unique
    if (entity) {
      throw new Error('Antenna Code is not unique.')
    }
  } catch (err) {
    const {
      message = UNCAUGHT_ERROR,
      res = {},
    } = err

    if (res.status === 404 && hasAsyncErrors) {
      // antenna code was unique but there were previous async errors we want to persist.
      throw asyncErrors
    } else if (res.status === 404) {
      // antenna code was unique and there are no async errors to persist.
      return
    }

    // if the error was not an API 404, capture the error message and throw that
    console.warn(err)
    setNestedValueInObject(asyncErrors, pathString, message)
    throw asyncErrors
  }

  // not sure how a user would get here but just in case, we'll pass
  // along any previous async errors which were on the form.
  if (hasAsyncErrors) {
    throw asyncErrors
  }
}

export default antennaCodeIsUnique
